module.exports = __webpack_public_path__ + "img/icone_documento_grafico_branco.a87ad372.svg";